@if (record(); as record) {
    @if ($isPlayableMedia()) {
        <med-media-player [record]="record"></med-media-player>
    } @else {
        <sh-image-viewer
            [imageSources]="[$recordPreviewUrl()]"
            [rotate]="'true'"
            [actionsPosition]="ViewerActionsPosition.BOTTOM_EXTERNAL"
            [customActionItems]="$customActionItems()"
            [fullscreen]="false"
            [allowTransform]="$allowTransform()"
            [faces]="$recordFaces()"
            style="height: 100%"
        ></sh-image-viewer>
    }
}
